module.exports = "<span class=\"text-center loaderdiv\" *ngIf='loading'>\r\n  <i class=\"fa fa-spinner fa-2x fa-spin\"></i>\r\n</span>\r\n"